const AGE_BANDS = [
  'AgeUnder18',
  'Age18To20',
  'Age21To25',
  'Age26To30',
  'Age31To35',
  'Age36To40',
  'Age41To45',
  'Age46To50',
  'Age51To60',
  'Age61OrAbove',
  'AgeUnknown',
];

const AGE_RANK = new Map(AGE_BANDS.map((value, index) => [value, index]));

function ageParts(value) {
  const text = String(value ?? '');
  const band = AGE_BANDS.find((candidate) => text === candidate || text.endsWith(` · ${candidate}`));
  return band ? { group: text.slice(0, -band.length), rank: AGE_RANK.get(band) } : null;
}

// Query results normally read best largest-first. Ordered vocabularies are the
// exception: an age profile is only readily comparable when every block uses
// the same youngest-to-oldest progression. A cohort prefix remains the primary
// key so multiple curated cohorts do not get interleaved.
export function compareQueryValues(a, b, valueSort = null) {
  if (valueSort !== 'age-band') return b.count - a.count;

  const left = ageParts(a.values[0]);
  const right = ageParts(b.values[0]);
  if (left && right) return left.group.localeCompare(right.group) || left.rank - right.rank;
  if (left) return -1;
  if (right) return 1;
  return String(a.values[0] ?? '').localeCompare(String(b.values[0] ?? ''));
}
